import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Col, Row, Spinner } from 'reactstrap'

import SstPostContentWidget from './partials/SstPostContentWidget'
import SstPostDetailsWidget from './partials/SstPostDetailsWidget'

import ModelCategoriesWidget from '../Categories/ModelCategoriesWidget'
import ModelTagsWidget from '../Tags/ModelTagsWidget'
import ModelMediasWidget from '../Medias/ModelMediasWidget'
import ModelCommentsWidget from '../Comments/ModelCommentsWidget'

import { getSstPost } from './services'
import { handleError } from '../../helpers'

export default function SstPostProfile(props) {
	const id = props.match.params.id
	const [sstPost, setSstPost] = useState(null)
	const [reload, setReload] = useState(true)

	useEffect(() => {
		reload && getSstPost(id, {
			include: 'user,medias,comments,categories,tags'
		})
			.then(res => setSstPost(res.data.data))
			.catch(error => handleError(error))
			.finally(() => setReload(false))
	}, [ reload, id ])

	if(!sstPost) return <Spinner />

	const morphProps = {
		model: sstPost,
		modelType: "sst_post",
		reload: () => setReload(true)
	}

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Detalles Generales</h6>
						</CardHeader>
						<CardBody>
							<SstPostDetailsWidget sstPost={sstPost} reload={() => setReload(true)} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Categorías de Publicaciones SST</h6>
						</CardHeader>
						<CardBody>
							<ModelCategoriesWidget {...morphProps} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Etiquetas de Publicaciones SST</h6>
						</CardHeader>
						<CardBody>
							<ModelTagsWidget {...morphProps} />
						</CardBody> 
					</Card>
				</Col>
				<Col>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Contenido</h6>
						</CardHeader>
						<CardBody>
							<SstPostContentWidget sstPost={sstPost} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Multimedia</h6>
						</CardHeader>
						<CardBody>
							<ModelMediasWidget {...morphProps} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Comentarios</h6>
						</CardHeader>
						<CardBody>
							<ModelCommentsWidget {...morphProps} />
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}